import OngoingOrder from './OngoingOrder';
import OrderBasketSummary from './OrderBasketSummary';
import OrderPaymentBreakdown from './OrderPaymentBreakdown';
import OrderRating from './OrderRating';
import OrderTimeline from './OrderTimeline';
import ScheduledOrderInfo from './ScheduledOrderInfo';
import OrderTracker from './OrderTracker';

export default {
  OngoingOrder,
  OrderBasketSummary,
  OrderPaymentBreakdown,
  OrderRating,
  OrderTimeline,
  ScheduledOrderInfo,
  OrderTracker,
};
